import { useMemo } from "react";
import { cn } from "@/lib/utils";

type EmailPreviewFrameProps = {
  html: string;
  viewport?: "desktop" | "mobile";
  className?: string;
};

export function EmailPreviewFrame({
  html,
  viewport = "desktop",
  className,
}: EmailPreviewFrameProps) {
  const srcDoc = useMemo(() => html, [html]);

  return (
    <div
      className={cn(
        "mx-auto overflow-hidden rounded-[1.5rem] border border-[#EBEBEB] bg-[#f6f4ef]",
        viewport === "mobile" ? "max-w-[390px]" : "w-full",
        className,
      )}
    >
      <iframe
        title="Email preview"
        srcDoc={srcDoc}
        sandbox=""
        className={cn(
          "block w-full bg-[#f6f4ef]",
          viewport === "mobile" ? "h-[640px]" : "h-[720px]",
        )}
      />
    </div>
  );
}
